<template>
 <div id="app">  
  <div class="container">

             
                    
  <span v-if="(this.item.AWR_MINER_VER != undefined && this.item.AWR_MINER_VER.includes('statspack')) ">                
<img  src="@/assets/statspack.png" height="20px"/><br/>Data was collected using STATSPACK.  The Exadata Observations section is a work-in-progress when using STATSPACK data.  Currently, there will be some missing data.  For best results, use aws_statspack_miner.sql version 4.0.11.statspack.<b>21</b> or later.<br/><br/>
 </span>                           

      <b-card-group deck v-if="this.item.additional_datapoints != undefined">
        <b-card header="IO Intensity">
          <img v-if="(this.item.Exadata=='Yes')&&(this.item.SmartScanEligible!=undefined)&&(this.item.SmartScanEligible==0)" src="@/assets/Exadata0.png" height="20px" v-b-popover.hover="`This database used to run on Exadata, but may not anymore. ${'Smart Scan Eligible= '+this.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.item.ExadataAdjustmentText==undefined) ? '' : this.item.ExadataAdjustmentText}`" title="Exadata - ZERO SmartScan Offload"></img>
          <img v-if="(this.item.Exadata=='Yes')&&(this.item.SmartScanEligible!=undefined)&&(this.item.SmartScanEligible>0)&&  (this.item.SmartScanEligible<500)" src="@/assets/Exadata1.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.item.ExadataAdjustmentText==undefined) ? '' : this.item.ExadataAdjustmentText}`" title="Exadata - Minimal SmartScan Offload"></img>
          <img v-if="(this.item.Exadata=='Yes')&&(this.item.SmartScanEligible!=undefined)&&(this.item.SmartScanEligible>500)&&  (this.item.SmartScanEligible<2000)" src="@/assets/Exadata2.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.item.ExadataAdjustmentText==undefined) ? '' : this.item.ExadataAdjustmentText}`" title="Exadata - Moderate SmartScan Offload"></img>
          <img v-if="(this.item.Exadata=='Yes')&&(this.item.SmartScanEligible!=undefined)&&(this.item.SmartScanEligible>2000)&&  (this.item.SmartScanEligible<8000)" src="@/assets/Exadata3.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.item.ExadataAdjustmentText==undefined) ? '' : this.item.ExadataAdjustmentText}`" title="Exadata - Medium SmartScan Offload"></img>
          <img v-if="(this.item.Exadata=='Yes')&&(this.item.SmartScanEligible!=undefined)&&(this.item.SmartScanEligible>8000)" src="@/assets/Exadata4.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.item.ExadataAdjustmentText==undefined) ? '' : this.item.ExadataAdjustmentText}`" title="Exadata - Heavy SmartScan Offload"></img>
          
          <br/><br/>
          
          <b-list-group>
            <b-list-group-item v-for="message in text_io.messages" :key="message.text" :variant="message.severity">{{ message.text }}</b-list-group-item>
          </b-list-group>
      
          <b-card-body>
            {{ this.text_io.body }}
          </b-card-body>
        </b-card>

     
        <b-card header="Workload Type">
          <img v-if="(this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1>0) && (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024 <= 30)" src="@/assets/OLTP1.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024)} KB, which makes this database appear to be supporting OLTP-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
          <img v-if="(this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1>0) && (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024 > 30) && (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024 <= 120)" src="@/assets/OLTP2.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024)} KB, which makes this database appear to be supporting OLTP-style workloads with some mixed workloads.`" title="OLTP-DW Spectrum Estimation"></img>
          <img v-if="(this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1>0) && (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024 > 120) && (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024 <= 400)" src="@/assets/OLTP3.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024)} KB, which makes this database appear to be supporting mixed and/or DW workloads.`" title="OLTP-DW Spectrum Estimation"></img>
          <img v-if="(this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1>0) && (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024 > 400)" src="@/assets/OLTP4.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024)} KB, which makes this database appear to be supporting DW-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
          <img v-if="(this.item.AWR_MINER_VER != undefined && !(this.item.AWR_MINER_VER.includes('aws') || this.item.AWR_MINER_VER.includes('statspack') ) )" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: This looks like the generic non-DBCSI AWR Miner script was used to collect metrics.  DBCSI works best if you use the DBCSI-specific data collection script downloadable from the DBCSI Add page.  Some DBCSI functionality will be missing."></img>         

          <br/><br/>
          <b-list-group>
            <b-list-group-item v-for="message in text_workload.messages" :key="message.text" :variant="message.severity">{{ message.text }}</b-list-group-item>
          </b-list-group>
      
          <b-card-body>
            {{ this.text_workload.body }}
          </b-card-body>
        </b-card>

      
      </b-card-group>  
      
      
      <br/><br/>
      
      <div v-if="this.item.additional_datapoints == undefined">Limited data.  Create a scenario in the Auto-Right-Sizer to collect/see more complete information.</div>  
      
      <b-card-group deck v-if="this.item.additional_datapoints != undefined">
        <b-card header="HCC Usage">
          <b-list-group>
            <b-list-group-item v-for="message in text_hcc.messages" :key="message.text" :variant="message.severity">{{ message.text }}</b-list-group-item>
          </b-list-group>
      
          <b-card-body>
            {{ this.text_hcc.body }}
          </b-card-body>
        </b-card>

        <b-card header="Memory Size">
          <b-list-group>
            <b-list-group-item v-for="message in text_memory.messages" :key="message.text" :variant="message.severity">{{ message.text }}</b-list-group-item>
          </b-list-group>
      
          <b-card-body>
            {{ this.text_memory.body }}
          </b-card-body>
        </b-card>

        <b-card header="Commit Rate">
          <b-list-group>
            <b-list-group-item v-for="message in text_commit.messages" :key="message.text" :variant="message.severity">{{ message.text }}</b-list-group-item>
          </b-list-group>
      
          <b-card-body>
            {{ this.text_commit.body }}
          </b-card-body>
        </b-card>

     </b-card-group >


      <br/><br/>
      
      
      <b-card-group deck>
        <b-card header="Key Exadata Metrics">
          <b-card-body>
              
              <timechart2container   v-if="loaded"
                                    id="divEXADATA"
                                  :collection_id="`${this.item.collectionID}`"
                                  collection_type="ora_v1"
                                  :user="user"
                                  label="Average Read Throughput:Average SmartScan Eligible:Average Storage Index Savings:Peak Read Throughput"
                                  chart_id="EXADATA"
                                  reflines="false"
                                  instance_num="all"
                                  stacked="false"
                                  :filter="`${(this.item.IS_PDB=='YES') ? this.item.CDB_IOMB*2 : 0}`"
                                  filter_prompt="(twice the p99 of Average CDB Throughput)"
                                  targets="Target"
                                  :targetValues="`${this.item.OrigThroughput}`"
                                  adjustment="1.0"
                                ></timechart2container>
              <img id="imgEXADATA" width="100%"/>                  
          </b-card-body>
        </b-card>


     </b-card-group >     



     <span style="font-size:12px" v-html="this.exadataAssumptions" v-if="this.item.additional_datapoints != undefined"></span>

      <br/><br/>
      
      
      <b-card-group deck v-if="text_tuning.messages.length>0">
        <b-card header="Post-Exadata Tuning and Tightening">
          <b-list-group>
            <b-list-group-item v-for="message in text_tuning.messages" :key="message.text" :variant="message.severity">{{ message.text }}</b-list-group-item>
          </b-list-group>
      
          <b-card-body>
            {{ this.text_tuning.body }}
          </b-card-body>
        </b-card>
     </b-card-group >     

       <br/><br/>     

      <b-card-group deck v-if="this.item.additional_datapoints != undefined">
        <b-card header="Additional Exadata Links and Resources">
          

            <p style="font-size:16px"><b><a href="https://d1.awsstatic.com/whitepapers/migrating-oracle-exadata-workloads-to-aws.pdf" target="_blank">[AWS White Paper] Migrating Oracle Exadata Workloads to AWS</a></b></p>

            <p style="font-size:16px"><b><a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/oracle-exadata-blueprint/introduction.html" target="_blank">[AWS Guidance] Blueprint for successful migrations from Oracle Exadata to AWS</a></b></p>

            <p style="font-size:16px"><b><a href="https://aws.amazon.com/blogs/database/migrating-oracle-databases-from-exadata-to-amazon-rds-for-oracle-addressing-performance-considerations/" target="_blank">[AWS Blog] Migrating Oracle Databases from Exadata to Amazon RDS for Oracle: Addressing Performance Considerations</a></b></p>

          <br/><br/>
          
            <p style="font-size:14px"><a href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-one-yavor-ivanov/" target="_blank">[Customer Blog - <b>Paysafe</b> - part1] Migrating Exadata workloads to AWS</a></p>
            <p style="font-size:12px"><a href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-two-rds-service-yavor-ivanov/" target="_blank">[part2] Migrating Exadata workloads to AWS, the RDS service</a></p>
            <p style="font-size:12px"><a href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-three-hard-core-yavor-ivanov/" target="_blank">[part3] Migrating Exadata workloads to AWS, hard-core EC2 services</a></p>
            <p style="font-size:12px"><a href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-four-using-data-yavor-ivanov/" target="_blank">[part4] Migrating Exadata workloads to AWS, using cloud-native data stores</a></p>
            <p style="font-size:12px"><a href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-five-ebs-volumes-yavor-ivanov/" target="_blank">[part5] Migrating Exadata workloads to AWS, EBS volumes for Oracle DBAs</a></p>
            <p style="font-size:12px"><a href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-six-predicting-storage-ivanov/" target="_blank">[part6] Predicting storage requirements</a></p>
          
          <br/><br/>
          
            <p style="font-size:14px"><a href="https://www.youtube.com/watch?v=QPcjuKTYdHk" target="_blank">[Customer Video - <b>CalHEERS</b>] Large-scale, Oracle Engineered Systems migration to the cloud</a></p>
            <p style="font-size:14px"><a href="https://aws.amazon.com/blogs/industries/edf-completes-ssgroundbreaking-migration-to-run-oracle-utilities-solution-on-amazon-rds/" target="_blank">[Customer Example - <b>EDF UK</b>] EDF Completes Groundbreaking Migration to Run Oracle Utilities Solution on Amazon RDS</a></p>
          
          <br/><br/>
          

            <p style="font-size:14px"><a href="https://aws.amazon.com/blogs/apn/comparing-oracle-exadata-database-performance-with-amazon-rds-for-oracle/" target="_blank">[Partner Blog - <b>TCS</b>] Comparing Oracle Exadata Database Performance with Amazon RDS for Oracle</a></p>
           <p style="font-size:14px"><a href="https://aws.amazon.com/blogs/apn/proving-the-performance-of-oracle-exadata-based-workloads-on-aws/" target="_blank">[Partner Blog - <b>Navisite</b>] Proving the Performance of Oracle Exadata-Based Workloads on AWS</a></p>
            <p style="font-size:14px"><a href="https://www.tekstream.com/blog/migrating-on-premises-oracle-exadata-databases-to-amazon-rds/" target="_blank">[Partner Blog - <b>Tekstream</b>] Migrating On-Premises Oracle Exadata Databases to Amazon RDS</a></p>
            <p style="font-size:14px"><a href="https://appsassociates.com/resources/whitepapers/modernize-your-exadata-workloads-with-aws/" target="_blank">[Partner White Paper - <b>Apps Associates</b>] Modernize your Exadata Workloads with AWS</a></p>
                    
          <!--<b-list-group>-->
          <!--  <b-list-group-item href="https://d1.awsstatic.com/whitepapers/migrating-oracle-exadata-workloads-to-aws.pdf" target="_blank">[AWS White Paper] Migrating Oracle Exadata Workloads to AWS</b-list-group-item>-->
          <!--</b-list-group>-->
          <!--<br/><br/>-->
          <!--<b-list-group>-->
          <!--  <b-list-group-item href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-one-yavor-ivanov/" target="_blank">[Customer Blog - Paysafe - part1] Migrating Exadata workloads to AWS</b-list-group-item>-->
          <!--  <b-list-group-item href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-two-rds-service-yavor-ivanov/" target="_blank">[part2] Migrating Exadata workloads to AWS, the RDS service</b-list-group-item>-->
          <!--  <b-list-group-item href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-three-hard-core-yavor-ivanov/" target="_blank">[part3] Migrating Exadata workloads to AWS, hard-core EC2 services</b-list-group-item>-->
          <!--  <b-list-group-item href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-four-using-data-yavor-ivanov/" target="_blank">[part4] Migrating Exadata workloads to AWS, using cloud-native data stores</b-list-group-item>-->
          <!--  <b-list-group-item href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-five-ebs-volumes-yavor-ivanov/" target="_blank">[part5] Migrating Exadata workloads to AWS, EBS volumes for Oracle DBAs</b-list-group-item>-->
          <!--  <b-list-group-item href="https://www.linkedin.com/pulse/migrating-exadata-workloads-aws-part-six-predicting-storage-ivanov/" target="_blank">[part6] Predicting storage requirements</b-list-group-item>-->
          <!--</b-list-group>-->
          <!--<br/><br/>-->
          <!--<b-list-group>-->
          <!--  <b-list-group-item href="https://aws.amazon.com/blogs/industries/edf-completes-ssgroundbreaking-migration-to-run-oracle-utilities-solution-on-amazon-rds/" target="_blank">[Customer Example - EDF UK] EDF Completes Groundbreaking Migration to Run Oracle Utilities Solution on Amazon RDS</b-list-group-item>-->
          <!--  <b-list-group-item href="https://www.youtube.com/watch?v=QPcjuKTYdHk" target="_blank">[Customer Video - CalHEERS] Large-scale, Oracle Engineered Systems migration to the cloud</b-list-group-item>-->
          <!--</b-list-group>-->
          <!--<br/><br/>-->
          <!--<b-list-group>-->

          <!--  <b-list-group-item href="https://aws.amazon.com/blogs/apn/comparing-oracle-exadata-database-performance-with-amazon-rds-for-oracle/" target="_blank">[Partner Blog - TCS] Comparing Oracle Exadata Database Performance with Amazon RDS for Oracle</b-list-group-item>-->
          <!-- <b-list-group-item href="https://aws.amazon.com/blogs/apn/proving-the-performance-of-oracle-exadata-based-workloads-on-aws/" target="_blank">[Partner Blog - Navisite] Proving the Performance of Oracle Exadata-Based Workloads on AWS</b-list-group-item>-->
          <!--  <b-list-group-item href="https://www.linkedin.com/feed/update/urn:li:activity:7058899636240994305" target="_blank">[Partner Blog - Tekstream] Migrating On-Premises Oracle Exadata Databases to Amazon RDS</b-list-group-item>-->
          <!--</b-list-group>-->
          
            <!--<b-list-group-item href="https://aws.amazon.com/blogs/database/use-oracle-real-application-testing-features-with-amazon-rds-for-oracle/" target="_blank">[AWS Blog] Use Oracle Real Application Testing features with Amazon RDS for Oracle</b-list-group-item>-->
            <!--<b-list-group-item href="https://aws.amazon.com/solutions/case-studies/edf-case-study/" target="_blank">[Customer Example - EDF UK -- alternate write-up]</b-list-group-item>-->




        </b-card>
     </b-card-group >     
         
     
   

   
  </div>
 </div>  
</template>

<script>
import { API } from "aws-amplify";
import ScatterChartContainer from "./ScatterChartContainer.vue";
import TimeBarChartNContainer from "./TimeBarChartNContainer.vue";
import TimeChart2Container from "./TimeChart2Container.vue";

export default {
  name: "ExadataObservations",
  components: {
    timebarchartncontainer: TimeBarChartNContainer,
    timechart2container: TimeChart2Container,
    scatterchartcontainer: ScatterChartContainer
  },
  props: ["param_collection_id", "user", "collection_type", "param_item"],
  data: () => ({
    loaded: false,
    shareMode: false,
    collection_id: "",
    item: {},
    text_io: { messages: [ ], body: ""},
    text_workload: { messages: [ ], body: ""},
    text_hcc: { messages: [ ], body: ""},
    text_memory: { messages: [ ], body: ""},
    text_commit: { messages: [ ], body: ""},
    text_tuning: { messages: [ ], body: ""},
    exadataAssumptions: ""

  }),
  async mounted() {
    this.loaded = false;
    
    // console.log("EO", this.param_item);
    this.item=JSON.parse(this.param_item);
    
    this.collection_id = this.param_collection_id;
    // is this shareMode?
    if ( (this.param_collection_id.substring(0,2)=="SD")  || (this.param_collection_id.substring(0,2)=="SB")) {
      // console.log("shareMode");
      this.collection_id=this.param_collection_id.substring(2).split('-')[1];
      this.shareMode=true;
    }
    


      
    
    var tries = 2;
    var batchsuccess=false;
    var isOK = true;
  //   while (tries > 0) {
  //     await API.get(
  //       "dbcsiAPI",
  //       `/dbcsi/authorized/${this.param_collection_id}`
  //     )
  //       .then(response => {
  //         if (response.data.authorized!="Y") {
  //           // console.log("Sorry, not authorized to view this collection.  Routing back to main page.");      
  //           // this.$router.push('/');
  //           tries = 0;
  //           isOK=false;
            
  //         }
  //       })
  //       .catch(error => {
  //         console.log("EO-authorized Error:", error);
  //         console.log("Will retry.  Attempts Left:", (tries-1));
  //       });
  //     tries -= 1;
		// }
		
		if (!isOK) return;
      
    
    // exit early if no additional_datapoints
    if (this.item.additional_datapoints == undefined) {
      this.loaded=true;
      return;
    }
    
    // define exadataAssumptions
    this.exadataAssumptions = "Target Exadata Throughput based on manual edits.<br/>";
     var IOThruAlgo = "manual edit";
    if (this.item.OrigThroughput==undefined) {
      this.exadataAssumptions="";
      IOThruAlgo="";
    }
   
    if (this.item.assumptionsArray!=undefined) {
      for (var i of this.item.assumptionsArray) {
        // if ( (i.category=="Throughput") || (i.category=="ExadataTuning") || (i.category=="ExadataTuning") || (i.category=="ExadataIOThreshold") || (i.category=="ExadataMemory") ) {
        if ( (i.category=="Throughput")  ) {
          this.exadataAssumptions = "Target Exadata Throughput values are calculated using your Algorithm selection ("+ i.text+").<br/>";
          IOThruAlgo = i.text;
        }
      }
    }  
    
      
    // now start making some assessments...
    
    // review IO Intensity
    var workString = "";
    var severity = "low";
    var recommendIOTuning = false;
    var messageCtr = 0;
    var tuningCtr = 0;
    
    var showTargetIO = true;
    var showMeasuredIO = true;
    
    // don't show TargetIO if we have no assumption/algos
    if (this.item.assumptionsArray==undefined) showTargetIO=false;
    // don.t show TargetIO if OrigThroughput is undefiend
    if (this.item.OrigThroughput==undefined) showTargetIO=false;
    
    // don't show MeasuredIO if it is the same?
    if (showTargetIO && Math.round(this.item.additional_datapoints.DB_IOMB_AVERAGE_P99) == Math.round(this.item.OrigThroughput)) showMeasuredIO = false;
    
    workString = "Target IO Throughput (pre-Tuning) is " +  Math.round(this.item.OrigThroughput) +" MB/s (" + IOThruAlgo + ").";
    if (this.item.OrigThroughput*1 > 4000) {
      severity="danger";
      workString = workString+" This is high.";
      recommendIOTuning=true;
    } else if (this.item.OrigThroughput*1 > 2000) {
      severity="warning";
      workString = workString+" This is moderate.";
      recommendIOTuning=true;
    }
    if (!showTargetIO) {
      messageCtr--;
    } else {
      this.text_io.messages[messageCtr] = {text: workString, severity: severity}; 
    }  
   
   if (showMeasuredIO) {
     severity = "low";
    workString = "Measured IO Throughput is " +  Math.round(this.item.additional_datapoints.DB_IOMB_AVERAGE_P99) +" MB/s (P99 of the averages).";
    if (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99*1 > 4000) {
      severity="danger";
      workString = workString+" This is high.";
      recommendIOTuning=true;
    } else if (this.item.additional_datapoints.DB_IOMB_AVERAGE_P99*1 > 2000) {
      severity="warning";
      workString = workString+" This is moderate.";
      recommendIOTuning=true;
    }
    messageCtr++;
    this.text_io.messages[messageCtr] = {text: workString, severity: severity}; 
     
   }
    
    // look at SmartScan
    severity = "low";
    workString = "Measured SmartScan Eligible is " +  Math.round(this.item.SmartScanEligible) +" MB/s (P99 of the averages).";
    if (this.item.SmartScanEligible*1 > 4000) {
      severity="danger";
      workString = workString+" This is high.";
      recommendIOTuning=true;
    } else if (this.item.SmartScanEligible*1 > 2000) {
      severity="warning";
      workString = workString+" This is moderate.";
      recommendIOTuning=true;
    }
    messageCtr++;
    this.text_io.messages[messageCtr] = {text: workString, severity: severity}; 
    
    // do we have a big non-SmartScan
    
    var nonSmartScan = this.item.additional_datapoints.DB_IOMB_AVERAGE_P99 - this.item.SmartScanEligible;
    if (nonSmartScan > 4000) {
      severity="danger";
      workString = "Non-Smart Scan Read IO is " +  Math.round(nonSmartScan) +" MB/s (P99 of the averages). This is high.";
      recommendIOTuning=true;
      messageCtr++;
      this.text_io.messages[messageCtr] = {text: workString, severity: severity}; 
    } else if (nonSmartScan > 2000) {
      severity="warning";
      workString = "Non-Smart Scan Read IO is " +  Math.round(nonSmartScan) +" MB/s (P99 of the averages). This is moderate.";
      recommendIOTuning=true;
      messageCtr++;
      this.text_io.messages[messageCtr] = {text: workString, severity: severity};
    }


    // look at Storage Index
    severity = "low";
    workString = "Measured Storage Index Usage is " +  Math.round(this.item.StorageIndexSavings) +" MB/s (P99 of the averages).";
    if (this.item.StorageIndexSavings*1 > 4000) {
      severity="danger";
      workString = workString+" This is high.";
      recommendIOTuning=true;
    } else if (this.item.StorageIndexSavings*1 > 2000) {
      severity="warning";
      workString = workString+" This is moderate.";
      recommendIOTuning=true;
    }
    messageCtr++;
    this.text_io.messages[messageCtr] = {text: workString, severity: severity}; 



    // do we have a good Storage Index oppty
    // SI savings are > 50% and SI savings are > 1000
    if ( (this.item.StorageIndexSavings*1 > 1000) && (this.item.SmartScanEligible != 0) ) {
    var SIusage = this.item.StorageIndexSavings / this.item.SmartScanEligible;
    if (SIusage >= 0.5) {
      severity="success";
      workString = "Storage Index savings are " +  Math.round(SIusage*100,0) +"% of the Smart Scan Eligible. This suggest a good opportunity to add traditional indexes to significantly reduce the IO requirements.";
      recommendIOTuning=true;
      messageCtr++;
      this.text_io.messages[messageCtr] = {text: workString, severity: severity}; 
    } 
      
    }
    





    // review Workload

    workString = "";
    severity = "low";
    var recommendWorkloadTuning = false;
    messageCtr = 0;
    // var requestSize = Math.round(this.item.OrigThroughput/this.item.OrigIOPS*1024);  
    var requestSize = Math.round(this.item.additional_datapoints.DB_IOMB_AVERAGE_P99/this.item.additional_datapoints.DB_IOPS_AVERAGE_P99*1024);  
    
    
    workString = "Estimated typical IO request size is " + requestSize + " KB.";
    severity = "";
    this.text_workload.messages[messageCtr] = {text: workString, severity: severity}; 

    // analyze request size
    severity = "low";
    workString = "This database appears to be supporting OLTP-style workloads.";

    if (requestSize > 400) {
      // severity="warning";
      workString = "This database appears to be supporting DW-style workloads.";
      recommendWorkloadTuning=true;
    } else if (requestSize > 120) {
      // severity="warning";
      workString = "This database appears to be supporting mixed and/or DW workloads.";
      recommendWorkloadTuning=true;
    } else if (requestSize > 30) {
      workString = "This database appears to be supporting OLTP-style workloads with some mixed workloads.";
      recommendWorkloadTuning=true;
    }
    messageCtr++;
    this.text_workload.messages[messageCtr] = {text: workString, severity: severity}; 
    
    
    

    // severity = "low";
    // workString = "DBCSI uses your IO Throughput and IOPS algorithms (IO Throughput = " + Math.round(this.item.OrigThroughput ) + " MB/s divided by IOPS = " + Math.round(this.item.OrigIOPS) + ") to calculate the typical IO request size.";
    // messageCtr++;
    // this.text_workload.messages[messageCtr] = {text: workString, severity: severity}; 

    // body
    this.text_workload.body = "";
    







    // review Memory
    workString = "";
    severity = "low";
    var recommendMemoryTuning = false;
    messageCtr = 0;
    var memSize = Math.round(this.item.additional_datapoints.DB_SGAPGA_TOTAL/this.item.NUM_INSTANCES);    

    // analyze request size
    severity = "";
    workString = "SGA+PGA per node is "+memSize+" GB.";
    this.text_memory.messages[messageCtr] = {text: workString, severity: severity}; 

    if ((memSize < 120) && recommendIOTuning) {
      severity="warning";
      workString = "This memory size seems small for a high IO database.";
      recommendMemoryTuning=true;
      messageCtr++;
      this.text_memory.messages[messageCtr] = {text: workString, severity: severity}; 
    }

    // body
    this.text_memory.body = "";
    
    






    // review HCC
    workString = "";
    severity = "low";
    var recommendHCCTuning = false;
    messageCtr = 0;
    var hccCount = this.item.additional_datapoints.COUNT_TABLES_HCC*1;    

    // analyze request size
    severity = "";
    workString = "Tables with Exadata Hybrid Columnar Compression = "+hccCount;
    if ((hccCount > 10) ) {
      severity="warning";
      recommendHCCTuning = true;
    }  
    if (isNaN(hccCount)) {
      workString = "Count of HCC tables not available in data. Please use a newer version of aws_awr_miner.sql";
    }
    this.text_hcc.messages[messageCtr] = {text: workString, severity: severity}; 


    // body
    this.text_hcc.body = "";
    
    




    // review Commits
    workString = "";
    severity = "low";
    var recommendCommitTuning = false;
    messageCtr = 0;
    var commitRate = this.item.additional_datapoints.DB_EXA_COMMITS_P99*1;    

    // analyze request size
    severity = "";
    workString = "Commit Rate = "+commitRate.toFixed(1) + "/sec (P99 of the averages)";
    this.text_commit.messages[messageCtr] = {text: workString, severity: severity}; 


    if ((commitRate > 300) ) {
      severity="warning";
      recommendCommitTuning = true;
      workString = "This commit rate is high.";
      messageCtr++;
      this.text_commit.messages[messageCtr] = {text: workString, severity: severity}; 
    }  
    


    // body
    this.text_commit.body = "";
    
    


    if (recommendIOTuning) {
      // this.text_io.body= "Planning on some post-Exadata Tuning & Tightening is recommended.  The objective is to lower your IO requirements while still meeting or improving your performance targets.  By lowering your IO requirements, you can match your workload to more reasonable and cost-effective configurations.";
      this.text_tuning.messages[tuningCtr] = {text: "Given that this database appears to be Higher IO, planning on some post-Exadata Tuning & Tightening is recommended.  The objective is to lower your IO requirements while still meeting or improving your performance targets.  By lowering your IO requirements, you can match your workload to more reasonable and cost-effective configurations.", severity: ""} ;
      tuningCtr++;

      this.text_tuning.messages[tuningCtr] = {text: "Post-Exadata Tuning & Tightening activities can include things like increasing the Memory size, adding some indexes, tuning certain top SQL, creating new materialized views, and other things like offloading LOBs to S3 or moving some analytics to downstream data lake environments.  Refer to the Paysafe Blog series for some details about how they reduced their IO needs by 2x to 10x while moving from Exadata to RDS-Oracle.", severity: ""} ;
      tuningCtr++;

    }

    if (recommendIOTuning && recommendWorkloadTuning) {
      // severity = "warning";
      // workString = "Given that this database appears to be Higher IO and has Data Warehousing aspects, you should consider if Amazon Redshift should be considered.";
      // messageCtr++;
      // this.text_workload.messages[messageCtr] = {text: workString, severity: severity} ;

      this.text_tuning.messages[tuningCtr] = {text: "Given that this database has some Data Warehousing workload aspects and is also Higher IO, you should consider Amazon Redshift as a possibility.", severity: ""} ;
      tuningCtr++;

    }

    if (recommendMemoryTuning) {

      // this.text_memory.body = "Leveraging a larger SGA can help with the post-Exadata transition in some cases.  In one customer example, they used a 16GB SGA on the Exadata nodes and their workload did 6000 MB/s of IO throughput.  The same workload (as verified with Real Application Testing) ran in the same time off-Exadata on an RDS-Oracle configuration with a 250GB SGA and only had to use 50 MB/s of IO Throughput.  In this case, the small Exadata SGA drove the Oracle optimizer to need to perform IO when the critical 'active' part of the customer dataset could reside mostly in memory with a larger SGA.";
      
      this.text_tuning.messages[tuningCtr] = {text: "Given the relatively small Memory size configured on the Exadata, leveraging a larger SGA can help with the post-Exadata transition.  In one customer example, they used 16GB of SGA on the Exadata nodes and their workload did 6000 MB/s of IO throughput.  The same workload ran in the same time (as verified with Real Application Testing) on an RDS-Oracle configuration with a 250GB SGA and only had to use 50 MB/s of IO Throughput.", severity: ""} ;
      tuningCtr++;
      // this.text_tuning.messages[tuningCtr] = {text: "[Memory Continued] "+ this.item.memory_target_comments + this.item.assumptionsArray[7].text, severity: ""} ;
      // tuningCtr++;
     

    }

    if (recommendCommitTuning) {

      // this.text_commit.body = "Consider if you can reduce the frequency of commits in your application.  Given that this database has a high commit rate, you may notice that post-Exadata commit latency becomes larger than before.";
      this.text_tuning.messages[tuningCtr] = {text: "Given the high commit rate, consider if you can reduce the frequency of commits in your application.  With such a high commit rate, you may notice differences in the post-Exadata commit latency more than before.", severity: ""} ;
      tuningCtr++;

    }

    if (recommendHCCTuning) {

      // this.text_hcc.body = "Consider doing further analysis to estimate the impact on removing Hybrid Columnar Compression and switching to BASIC or ADVANCED compression.  It can also be worthwhile to consider archiving some historical data to a platform like an S3-based data lake for cheaper storage.";
      this.text_tuning.messages[tuningCtr] = {text: "Given that you have some HCC tables, consider doing further analysis.  Switching to BASIC or ADVANCED compression can be a good option post-Exadata.  It can also be worthwhile to consider archiving historical compressed data to a platform like parquet files in an S3-based data lake for much cheaper storage.", severity: ""} ;
      tuningCtr++;

    }

// console.log("EO", this.text_tuning.messages.length);

    this.loaded = true;

  }
};
</script>